import Container from "../component/Container";

import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Building2 } from "lucide-react";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 6,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 4,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 3,
  },
};

const data = [
  { img: "/220px-Brigade_Group_Official_Logo-150x150.jpeg" },
  { img: "/sattvaLogo.jpg" },
  { img: "/dlf-g1-150x150.jpg" },
  { img: "/Embassy_Group_Logo-150x150.png" },
  { img: "/Godrej-Logo-Design-150x150.jpg" },
  { img: "/hirajan152021lkjghty_pAPYvXO-150x150.jpg" },
  { img: "/prestige-logo-C58DC32DC3-seeklogo.com_-150x150.png" },
  { img: "/sobha-developers-logo-A13E8BA5BA-seeklogo.com_-150x150.png" },
];

function Patners() {
  return (
    <section className="clients relative overflow-hidden border-t border-slate-100 bg-white py-12 md:py-16 padingm">
      <div
        className="pointer-events-none absolute right-0 top-0 h-48 w-48 rounded-full bg-[#FECE51]/10 blur-3xl"
        aria-hidden
      />
      <Container className="relative max-w-6xl space-y-6 px-4 md:space-y-8 md:px-6">
        <header className="mx-auto max-w-2xl text-center md:text-left lg:mx-0">
          <div className="mb-3 flex justify-center md:justify-start">
            <span className="inline-flex items-center gap-2 rounded-full border border-slate-200/90 bg-white px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-[#727272] shadow-sm">
              <Building2 className="h-3.5 w-3.5 text-[#0F172A]" aria-hidden />
              Partners
            </span>
          </div>
          <h2 className="text-[#0F172A]">Featured Builders In India</h2>
          <p className="mx-auto mt-2 max-w-lg text-[14px] text-[#727272] md:mx-0">
            The most reputed builders in India
          </p>
          <hr className="mx-auto mt-4 h-1 w-24 rounded-full bg-[#FECE51] md:mx-0" />
        </header>

        <div className="rounded-2xl border border-slate-200/80 bg-white p-4 shadow-[0_8px_30px_rgba(15,23,42,0.05)] md:p-6">
          <Carousel
            swipeable={true}
            draggable={true}
            responsive={responsive}
            ssr={true}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={2800}
            keyBoardControl={true}
            customTransition="all 0.45s ease"
            transitionDuration={450}
            containerClass="carousel-container partner-logo-carousel"
            removeArrowOnDeviceType={["tablet", "mobile"]}
            dotListClass="custom-dot-list-style home-carousel-dots--projects"
            itemClass="carousel-item-padding-50-px flex items-stretch"
            className="z-10 py-2"
          >
            {data.map((item, index) => (
              <div
                key={item.img ?? index}
                className="mx-1 flex h-[128px] items-center justify-center rounded-xl border border-gray-100 bg-white px-4 py-6 shadow-sm transition hover:border-[#FECE51]/60 hover:shadow-md md:mx-2 md:h-[148px] lg:h-[160px]"
              >
                <img
                  src={item.img}
                  alt=""
                  className="h-auto max-h-[72px] w-auto max-w-[200px] object-contain md:max-h-[88px] md:max-w-[240px] lg:max-h-[100px] lg:max-w-[260px]"
                />
              </div>
            ))}
          </Carousel>
        </div>
      </Container>
    </section>
  );
}

export default Patners;
